import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Typography, TypographyProps } from '@mui/material';
import { useConnectionDisplayName } from './useConnectionDisplayName';

type Props = {
  connection: Pick<SocialExportGetConnectionStateDto, 'name' | 'profile'>;
  platform: SocialPlatform;
} & TypographyProps;

/**
 * Displays the connection label: custom `name` when set, otherwise profile display name
 * (or a generic default for platforms without a user profile).
 */
export function ConnectionDisplayName({ connection, platform, ...typographyProps }: Props) {
  const displayName = useConnectionDisplayName(connection, platform);

  return <Typography {...typographyProps}>{displayName}</Typography>;
}
